'use strict';

(function (angular) {
  angular.module('zp').directive('jcarousel', jcarouselDirective);

  /**@ngInject */
  function jcarouselDirective() {
    return {
      link: link,
      restrict: 'E',
      scope: {
        images: '='
      }
    };

    function link(scope, elm) {
      var items = scope.images;
      var ul = angular.element('<ul class="jcarousel-skin-tango"></ul>');

      // append the carousel into DOM
      elm.append(ul);
      ul.jcarousel();

      // dynamically add items
      angular.forEach(items, function (img, i) {
        ul.jcarousel('add', i + 1, '<img src="' + img.url + '" />');
      });
      ul.jcarousel('size', items.length);
    };
  }
})(window.angular);